
import { Vue, Options } from "vue-class-component";

@Options({
  name: "PremiumText",
  props: {
    isPremiumExpired: {
      type: Boolean,
    },
    isYearlyPlan: {
      type: Boolean,
    },
  },
})
export default class PremiumText extends Vue {
  private readonly isPremiumExpired!: boolean;
  private readonly isYearlyPlan!: boolean;

  protected get text(): string {
    const monthlyPrice = this.$t("premium.text.monthly_price", {
      monthly_price: "$7.95",
    });
    const yearlyPrice = this.$t("premium.text.yearly_price", {
      yearly_price: "$79.95",
    });

    if (!this.isPremiumExpired && this.isYearlyPlan) {
      return this.$t("premium.text.active_yearly");
    }

    return this.isYearlyPlan ? yearlyPrice : monthlyPrice;
  }
}
